if (!customElements.get('voicsky-keyboard-landing')) {
  customElements.define('voicsky-keyboard-landing', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-vkl-track]');
      this.previous = this.querySelector('[data-vkl-previous]');
      this.next = this.querySelector('[data-vkl-next]');
      this.track?.querySelectorAll('[data-vkl-model]').forEach((card) => window.voicskyIsMarketVisible?.(card));
      this.addEventListener('click', this.onClick);
      this.track?.addEventListener('keydown', this.onKeyDown);
      this.track?.addEventListener('scroll', this.updateControls, { passive: true });
      this.observer = new ResizeObserver(this.updateControls);
      if (this.track) this.observer.observe(this.track);
      this.updateControls();
    }
    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      this.track?.removeEventListener('scroll', this.updateControls);
      this.track?.removeEventListener('keydown', this.onKeyDown);
      this.observer?.disconnect();
      this.querySelectorAll('.vkl__image').forEach((image) => image.getAnimations().forEach((animation) => animation.cancel()));
    }
    imageChanges = new WeakMap();
    changeImage = async (image, source) => {
      const change = {};
      this.imageChanges.set(image, change);
      image.getAnimations().forEach((animation) => animation.cancel());
      const preview = new Image();
      preview.src = source;
      try { await preview.decode(); } catch { return; }
      if (!this.isConnected || this.imageChanges.get(image) !== change) return;
      const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (!reducedMotion) {
        await image.animate([{ opacity: 1 }, { opacity: 0 }], { duration: 140, easing: 'ease-out', fill: 'forwards' }).finished.catch(() => {});
      }
      if (!this.isConnected || this.imageChanges.get(image) !== change) return;
      image.removeAttribute('srcset');
      image.src = source;
      image.getAnimations().forEach((animation) => animation.cancel());
      if (!reducedMotion) image.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 200, easing: 'ease-out' });
    };
    updateControls = () => {
      if (!this.track) return;
      const max = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
      if (!this.previous || !this.next) return;
      this.previous.disabled = this.track.scrollLeft <= 2;
      this.next.disabled = this.track.scrollLeft >= max - 2;
      this.querySelector('[data-vkl-controls]').hidden = max <= 2;
    };
    onKeyDown = (event) => {
      if (event.target !== this.track || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
      event.preventDefault();
      if (event.key === 'ArrowLeft') this.previous?.click();
      if (event.key === 'ArrowRight') this.next?.click();
      if (event.key === 'Home' || event.key === 'End') this.track.scrollTo({left:event.key === 'Home' ? 0 : this.track.scrollWidth, behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
    };
    onClick = (event) => {
      const button = event.target.closest('button');
      if (!button || !this.contains(button)) return;
      if (button.hasAttribute('data-vkl-color')) {
        const card = button.closest('[data-vkl-model]');
        card.querySelectorAll('[data-vkl-color]').forEach((pill) => pill.setAttribute('aria-pressed', String(pill === button)));
        card.querySelector('[data-vkl-color-label]').textContent = button.dataset.vklColor;
        card.querySelectorAll('[data-vkl-link]').forEach((link) => { link.href = button.dataset.vklUrl; });
        const image = card.querySelector('img');
        if (image && button.dataset.vklImage) {
          this.changeImage(image, button.dataset.vklImage);
        }
        return;
      }
      if (button === this.previous || button === this.next) {
        const card = this.track.querySelector('[data-vkl-model]:not([hidden])');
        if (!card) return;
        const step = card.getBoundingClientRect().width + (parseFloat(getComputedStyle(this.track).columnGap) || 0);
        this.track.scrollBy({ left: step * (button === this.previous ? -1 : 1), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      }
    };
  });
}

if (!customElements.get('voicsky-shopping-guide')) {
  customElements.define('voicsky-shopping-guide', class extends customElements.get('voicsky-keyboard-landing') {});
}
